<template src="../../public/theme/base/profile.html"></template>

<script>
export default {
  name: 'profileComponent',
  computed: {
    profile() {
      return this.$store.getters.getSection('profile')
    },
  },
}
</script>
